<template>
    <div v-show="h5ConfigData.bottomDiversionFlag || h5ConfigData.bottomShareFlag" class="bt-wrap">
        <button v-show="h5ConfigData.bottomDiversionFlag" class="bt-lf" @click="toRobotGame">认领AI机器人</button>
        <button v-show="h5ConfigData.bottomShareFlag" class="bt-rt" @click="showShareBoard">邀请朋友体验</button>
    </div>
</template>

<script>
export default {
  props: {
    h5ConfigData: {
      type: Object
    }
  },

  methods: {
    toRobotGame () {
      window.open('https://ba.dui.ai/robotgame')
    },

    showShareBoard () {
      this.$emit('update:ifShowShareBoard', true)
    }
  }
}
</script>

<style lang="scss" scoped>
button {
    display: inline-block;
    line-height: 36px;
    padding: 12px 32px;
    border: none;
    border-radius: 36px;
    font-size: 32px; /*px*/
    font-weight: 500;
    text-align: center;
    white-space: nowrap;
    color: #ffffff;
    -webkit-appearance: none;
    outline: none;
    transition: 0.1s;
    user-select: none;
    cursor: pointer;
}

.bt {
    &-wrap {
        display: flex;
        justify-content: space-between;
        padding: 0 60px;
    }

    &-lf {
        background: linear-gradient(310deg, rgba(87, 187, 252, 1) 0%, rgba(60, 41, 250, 1) 100%);
        box-shadow: 0px 7px 15px 0px rgba(115, 122, 237, 0.37);
    }

    &-rt {
        background: linear-gradient(135deg, rgba(251, 65, 96, 1) 0%, rgba(252, 190, 87, 1) 100%);
        box-shadow: 0px 7px 15px 0px rgba(240, 81, 48, 0.37);
    }
}
</style>



// WEBPACK FOOTER //
// src/app/GenH5/SimulatorBt.vue